import { render, staticRenderFns } from "./InvestmentOptionDetailPanel.vue?vue&type=template&id=2e500397&scoped=true"
import script from "./InvestmentOptionDetailPanel.vue?vue&type=script&lang=js"
export * from "./InvestmentOptionDetailPanel.vue?vue&type=script&lang=js"
import style0 from "./InvestmentOptionDetailPanel.vue?vue&type=style&index=0&id=2e500397&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e500397",
  null
  
)

export default component.exports